import React, { useEffect, useMemo, useState } from "react";
import { Card, Tabs } from "antd";
import { useAuth } from "../../../context/AuthContext";
import PageHeader from "../../../components/PageHeader";
import { pageShellStyle } from "../../../theme";

import AdminCostMonitoring from "../../../pages/AdminCostMonitoring";
import AdminUserBudgetsPage from "./AdminUserBudgetsPage";
import AdminGroupBudgetsPage from "./AdminGroupBudgetsPage";
import AdminBudgetRequestsPage from "./AdminBudgetRequestsPage";
import GroupBudgetPoolCards from "../components/GroupBudgetPoolCards";

export default function AdminBudgetsPage() {
  const { token, isSuperAdmin, isAdmin } = useAuth();
  const isGroupAdmin = isAdmin && !isSuperAdmin;
  const [tab, setTab] = useState(isSuperAdmin ? "groups" : "project");

  useEffect(() => {
    setTab(isSuperAdmin ? "groups" : "project");
  }, [isSuperAdmin]);

  const tabItems = useMemo(() => {
    if (isGroupAdmin) {
      return [
        {
          key: "project",
          label: "Project budget",
          children: (
            <div style={{ marginTop: 8 }}>
              <AdminCostMonitoring />
            </div>
          ),
        },
        {
          key: "users",
          label: "User budgets",
          children: (
            <div style={{ marginTop: 8 }}>
              <AdminUserBudgetsPage />
            </div>
          ),
        },
        {
          key: "requests",
          label: "Requests",
          children: (
            <div style={{ marginTop: 8 }}>
              <AdminBudgetRequestsPage />
            </div>
          ),
        },
      ];
    }

    return [];
  }, [isGroupAdmin]);

  const subtitle = isSuperAdmin
    ? "Assign budget caps to groups and track utilization across groups and their projects."
    : "Configure project budgets and per-user allocations within your projects. Review extension requests.";

  if (!isAdmin) {
    return (
      <div style={{ ...pageShellStyle, padding: 18 }}>
        <PageHeader title="Budgets" subtitle="Admin access required." />
      </div>
    );
  }

  if (isSuperAdmin) {
    return (
      <div style={{ ...pageShellStyle, padding: 18 }}>
        <PageHeader title="Budgets" subtitle={subtitle} />
        <AdminGroupBudgetsPage />
      </div>
    );
  }

  return (
    <div style={{ ...pageShellStyle, padding: 18 }}>
      <PageHeader title="Budgets" subtitle={subtitle} />
      {isGroupAdmin ? <GroupBudgetPoolCards token={token} enabled /> : null}
      <Card>
        <Tabs activeKey={tab} onChange={setTab} destroyInactiveTabPane items={tabItems} />
      </Card>
    </div>
  );
}
